import {AfterViewInit, Component, forwardRef, inject, input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from "@angular/forms";
import {SubDistrict} from "../../../../generated-model/model";
import {debounceTime, distinctUntilChanged, finalize, Observable, of, Subject} from "rxjs";
import {CommonModule} from "@angular/common";
import {SharedCommonModule} from "../../commons/shared-common.module";
import {SubDistrictResource} from "../../../service/SubDistrictResource";

@Component({
  selector: 'app-subdistrict-autocomplete',
  templateUrl: './sub-district-autocomplete.component.html',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SubDistrictAutocompleteComponent),
      multi: true
    }
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedCommonModule
  ]
})
export class SubDistrictAutocompleteComponent implements ControlValueAccessor, OnInit, AfterViewInit, OnChanges {

  subDistricts$: Observable<SubDistrict[]> = of([]);
  term$ = new Subject<string>();
  typeaheadLoading = false;
  value: SubDistrict = undefined;
  id = input<string>('subDistrict');
  name = input<string>('subDistrict');
  districtId = input<string>();
  disabled = input<boolean>();
  private subDistrictResource = inject(SubDistrictResource);
  onChange = (value) => {
  };
  onTouched = () => {
  };

  compareWithCode = (o1: any, o2: any): boolean => {
    return (o1 == o2) || ((!!o1 && !!o2) && (o1.code == o2.code))
  };

  constructor() {
  }

  ngAfterViewInit() {
  }

  ngOnInit(): void {
    this.term$
      .pipe(distinctUntilChanged(), debounceTime(500))
      .subscribe(term => {
        this.typeaheadLoading = true;
        this.subDistricts$ = this.subDistrictResource.search(term, this.districtId())
          .pipe(finalize(() => this.typeaheadLoading = false));
      });
  }

  writeValue(value: SubDistrict) {
    this.value = value;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  valueChange(value: SubDistrict) {
    this.onChange(value);
    this.onTouched();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }
}
